import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../Components/Table";
import VendaDoRegistro from "./VendaDoRegistro";
import {
    AtualizarStatusController,
    DeletarVendaController,
    ListarVendaController,
} from "../../../Controllers/Geral/RegistraVenda/RegistraVendaControllers";
import { Link } from "react-router-dom";
import { ACESSOS } from "../../../Routes/Acessos";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import StickyToolbar from "../../../Components/StickyToolbar";
import {
    IEmpreendimento,
    IUnidade,
} from "../../../Interfaces/Geral/Produtos/ProdutosInterface";
import { useEffect, useState } from "react";
import { ListarEmpreendimentosController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import {
    IVenda,
    IVendaFilter,
} from "../../../Interfaces/Geral/RegistraVenda/RegistraVendaInterface";
import FilterRegistroVendaRow from "./FilterRegistroVendaRow";

const filtroInicial = {
    DS_NOME: "",
    ID_EMPREENDIMENTO: 0,
    ID_UNIDADE: 0,
    DT_VENDA: "",
};

export default function RegistraVenda() {
    const { execute: deletarVenda, loading: deletarLoading } = useAsyncCallback(
        DeletarVendaController
    );

    const { execute: ativarVenda, loading: ativarVendaLoading } =
        useAsyncCallback(AtualizarStatusController);

    const FILTRO_REGISTRO_VENDAS = sessionStorage.getItem(
        "FILTRO_REGISTRO_VENDAS"
    );
    const [idEmpreendimento, setIdEmpreendimento] = useState<string | number[]>(
        []
    );
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [lstEmpreendimentos, SetLstEmpreendimentos] = useState(
        [] as Array<IEmpreendimento>
    );
    const [lstVendas, setLstVendas] = useState<Array<IVenda>>([]);
    const [lstUnidades, setLstUnidades] = useState([] as Array<IUnidade>);
    const [pagina, setPagina] = useState(1);
    const [flag, setFlag] = useState(0);
    const [filter, setFilter] = useState<any>(
        FILTRO_REGISTRO_VENDAS
            ? JSON.parse(FILTRO_REGISTRO_VENDAS)
            : filtroInicial
    );

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (flag === 0) {
            ListarEmpreendimentosController().then((res) => {
                SetLstEmpreendimentos(res);
            });
        }
        updateVendas(pagina, filter);
    }, [pagina, filter, flag]);

    const tableColumns: Array<ColumnDescription> = [
        {
            dataField: "DS_EMPREENDIMENTO",
            text: "Vendas",
            formatter: (_, row) => (
                <VendaDoRegistro
                    venda={row}
                    setFlag={setFlag}
                    deletarVenda={deletarVenda}
                    ativarVenda={ativarVenda}
                />
            ),
        },
    ];

    function updateVendas(page: number, filter: IVendaFilter) {
        setLoading(true);
        ListarVendaController(page, 10, {
            ...filter,
            ID_EMPREENDIMENTO: filter.ID_EMPREENDIMENTO
                ? filter.ID_EMPREENDIMENTO
                : 0,
        })
            .then((response) => {
                setLstVendas(response.CONTAS_PRODUTOS);
                setTotalPaginas(response.NR_PAGINAS);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <div>
            <div className="w-100 d-flex justify-content-end">
                <Link
                    to={ACESSOS.GERAL.TELAS.REGISTRO_VENDA.REGISTRAR.DS_PATH}
                    className="btn btn-outline-primary mb-4 mr-4"
                >
                    Registrar Venda
                </Link>
            </div>
            <Table
                data={lstVendas ?? []}
                loading={loading || deletarLoading || ativarVendaLoading}
                columns={tableColumns}
                onTableChange={(type, newState) => {
                    setPagina(newState.page);
                }}
                keyField={"ID_CONTA_PRODUTO"}
                bordered={false}
                noSearch
                hover={false}
                remote={{ pagination: true }}
                totalPages={totalPaginas}
            />
            <StickyToolbar
                Filters={
                    <FilterRegistroVendaRow
                        setTotalPaginas={setTotalPaginas}
                        idEmpreendimento={idEmpreendimento}
                        setLstUnidades={setLstUnidades}
                        lstEmpreendimentos={lstEmpreendimentos}
                        lstUnidades={lstUnidades}
                        setFilter={setFilter}
                        setLstVendas={setLstVendas}
                        setLoading={setLoading}
                        setFlag={setFlag}
                        updateVendas={updateVendas}
                        setPagina={setPagina}
                        filter={{
                            ...filter,
                            ID_EMPREENDIMENTO: idEmpreendimento,
                            DS_NOME: filter.DS_NOME,
                            ID_UNIDADE: filter.ID_UNIDADE,
                        }}
                        setIdEmpreendimento={setIdEmpreendimento}
                    />
                }
                active={!!FILTRO_REGISTRO_VENDAS}
            />
        </div>
    );
}
